import type { TourDefinition } from "@/types/tour";

export const entrepreneurOnboarding: TourDefinition = {
  id: "entrepreneur-onboarding",
  context: "entrepreneur",
  version: 3,
  path: "/dashboard",
  steps: [
    {
      popover: {
        title: "Welcome to your dashboard",
        description:
          "Let's take a quick tour of your personal space. We'll highlight the key areas so you know where everything is.",
      },
    },
    {
      element: '[data-tour-id="dashboard-opportunities"]',
      popover: {
        title: "Matched opportunities",
        description:
          'Opportunities matched to your profile appear here. Click "View details" to learn more or apply directly.',
      },
    },
    {
      element: '[data-tour-id="dashboard-opportunities-view-all"]',
      popover: {
        title: "See all recommendations",
        description:
          "Here you can see all recommended opportunities based on your profile and preferences.",
      },
    },
    {
      element: '[data-tour-id="dashboard-sectors"]',
      popover: {
        title: "Sectors & industries",
        description:
          "Explore industries that match your background. Click any sector to see related opportunities.",
      },
    },
    {
      element: '[data-tour-id="dashboard-applications"]',
      popover: {
        title: "Your applications",
        description:
          "Track the status of your applications here. You'll see updates as reviewers provide feedback.",
      },
    },
    {
      element: '[data-tour-id="sidebar-profile"]',
      popover: {
        title: "Keep your profile updated",
        description:
          "Click here to update your profile. A complete profile means better opportunity matches.",
      },
    },
  ],
};
